import React, { Component } from "react";
import { TextField } from "reactackle";
import SelectDropdownForGrid from "../../FieldsComponents/SelectDropdown/SelectDropdownForGrid";
import { IconSvg } from "reactackle-icons";
import { Button } from "reactackle";
import getTableFields from "../../../TableDefinitions/getTableFields";

export default class MenuColumnsDataGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        path: "",
        payload: this.props.data
      }
    };
  }

  getFieldNameInput = (obj, arrIndex) => {
    //console.log("~~~" + JSON.stringify(this.props.fullFieldVal));
    return (
      <div
        style={{
          paddingLeft: "1px",
          textAlign: "left",
          border: "1px solid gainsboro",
          height: "45px"
        }}
      >
        <SelectDropdownForGrid
          title={"Title"}
          data={
            this.props.tableName &&
            this.props.tableName !== undefined &&
            getTableFields(this.props.createTableList, this.props.tableName)
          }
          label={"label"}
          placeholder={"placeholder"}
          value={
            obj && obj !== undefined ? obj[this.props.recLimitFieldName] : ""
          }
          stateFieldName={this.props.recLimitFieldName}
          isPayload={true}
          fieldName={"name"}
          arrayIndex={arrIndex}
          stateHandler={(val, id, isPayload) => {
            console.log(val);
            this.itemHandler(id, val, arrIndex);
            //this.props.limitHandler(val, "displayToggle", arrIndex);
          }}
        />
      </div>
    );
  };

  getFieldValInput = (obj, arrIndex) => {
    return (
      <div
        style={{
          paddingLeft: "1px",
          textAlign: "right",
          border: "1px solid gainsboro",
          height: "45px"
        }}
      >
        <TextField
          value={
            obj && obj !== undefined ? obj[this.props.recLimitFieldVal] : ""
          }
          onChange={e => {
            this.itemHandler(this.props.recLimitFieldVal, e.value, arrIndex);
          }}
          fullWidth
          disabled={false}
        />
      </div>
    );
  };

  getColId = colCaption => {
    //console.log("colCaption is: " + colCaption);
    let allCols =
      this.props.tableName &&
      this.props.tableName !== undefined &&
      getTableFields(this.props.createTableList, this.props.tableName);
    //console.log(JSON.stringify(allCols));
    let tmpObj = allCols.filter(item => item.name === colCaption);
    let tgtObj = tmpObj[0];
    //console.log("tmpObj: " + JSON.stringify(tmpObj));
    //console.log("tgtObj: " + JSON.stringify(tgtObj));
    return tgtObj && tgtObj.fieldName ? tgtObj.fieldName : "";
  };

  itemHandler = (fldName, val, rowNum) => {
    // console.log(
    //   rowNum +
    //     ":" +
    //     fldName +
    //     ":" +
    //     JSON.stringify(val) +
    //     " propName: " +
    //     this.props.recLimitFieldName
    // );
    let newArray = _.cloneDeep(this.props.value);
    // console.log(
    //   this.props.arrIndex +
    //     ":" +
    //     rowNum +
    //     ":" +
    //     JSON.stringify(newArray[rowNum])
    // );
    if (fldName === this.props.recLimitFieldName) {
      //console.log("matches");
      newArray[rowNum] = {
        ...newArray[rowNum],
        [fldName]: val,
        colKey: this.getColId(val)
      };
    } else {
      newArray[rowNum] = {
        ...newArray[rowNum],
        [fldName]: val
      };
    }

    // console.log(
    //   this.props.arrIndex +
    //     ":" +
    //     rowNum +
    //     ":" +
    //     JSON.stringify(newArray[rowNum])
    // );
    this.props.stateChangeHandler(newArray, this.props.arrIndex);
  };

  getInputRows = () => {
    if (this.props.value && this.props.value.length > 0) {
      return this.props.value.map((val, arrIndex) => {
        return (
          <tr>
            <td style={{ width: "45px" }}>{this.getDelIcon(arrIndex)}</td>
            <td style={{ width: "45px" }}>{this.getPlusIcon(arrIndex)}</td>
            <td>{this.getFieldNameInput(val, arrIndex)}</td>
            <td>{this.getFieldValInput(val, arrIndex)}</td>
          </tr>
        );
      });
    } else {
      return (
        <Button
          text="Add Data Restrictions"
          onPress={() => {
            this.props.stateChangeHandler(
              [
                {
                  [this.props.recLimitFieldName]: "",
                  [this.props.recLimitFieldVal]: ""
                }
              ],
              this.props.arrIndex
            );
          }}
          colorScheme="primary"
          outlined
        />
      );
    }
  };

  move = (oldIndex, newIndex) => {
    let array = _.cloneDeep(this.props.value);
    //console.log("before: " + JSON.stringify(array));
    if (newIndex >= array.length) {
      newIndex = array.length - 1;
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    //console.log("after: " + JSON.stringify(array));
    this.props.stateChangeHandler(
      array,
      this.props.stateFieldName,
      this.props.isPayload,
      this.props.arrIndex
    );
  };

  getDelIcon = rowNum => {
    return (
      <div
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.itemDeleteHandler(rowNum);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  getUpIcon = rowNum => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.move(rowNum, rowNum - 1);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };
  getDownIcon = rowNum => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.move(rowNum, rowNum + 1);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  getPlusIcon = rowNum => {
    return (
      <div
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          href="_"
          onClick={event => {
            event.preventDefault();
            this.itemAddHandler(rowNum);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  itemUpdateHandler = (rowNum, newVal) => {
    //console.log("rowNum: " + rowNum + " updated: " + newVal);

    let tmpData = _.cloneDeep(this.props.value);
    //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
    tmpData[rowNum][this.props.fieldNameInArray] = newVal;
    //console.log("After: " + JSON.stringify(tmpData[rowNum]));

    this.props.stateChangeHandler(
      tmpData,
      this.props.stateFieldName,
      this.props.isPayload
    );
  };

  itemAddHandler = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    let tmpData = _.cloneDeep(this.props.value);
    //console.log("Before: " + JSON.stringify(tmpData));
    tmpData.splice(rowNum + 1, 0, this.props.emptyRow);

    //console.log("After: " + JSON.stringify(tmpData));
    this.props.stateChangeHandler(tmpData, this.props.arrIndex);
  };

  itemDeleteHandler = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    let tmpData = _.cloneDeep(this.props.value);
    //console.log("Before: " + JSON.stringify(tmpData));
    delete tmpData[rowNum];

    tmpData = tmpData.filter(item => item !== null);
    //console.log("at filter:" + JSON.stringify(currActionsList));

    this.props.stateChangeHandler(tmpData, this.props.arrIndex);
  };

  getAvailableChoices = () => {
    let availableChoices = [];

    // for (let i = 0; i < this.props.fieldsList.length; i++) {
    //   //console.log("~ " + this.props.fieldsList[i].name);
    //   if (!this.props.value.includes(this.props.fieldsList[i].menu)) {
    //     //console.log("~ included - " + this.props.fieldsList[i].name);
    //     availableChoices.push(this.props.fieldsList[i]);
    //   } else {
    //     //console.log("~ excluded - " + this.props.fieldsList[i].name);
    //   }
    // }
    return availableChoices;
  };

  render() {
    return <table className="table table-striped">{this.getInputRows()}</table>;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Screens/ControlEngine/StaticList/MenuColumnsDataGrid.jsx